module.exports = __webpack_public_path__ + "img/Dschungel.007e4776.svg";